__turbopack_context__.v({
  "highlighted": "Zb5AGa_highlighted",
  "legend": "Zb5AGa_legend",
  "legendItem": "Zb5AGa_legendItem",
  "marker": "Zb5AGa_marker",
  "selected": "Zb5AGa_selected",
  "today": "Zb5AGa_today",
});
